/* @flow */

import { genRuby } from '@sonyged/ext-proc';

type Props = {
  children: string,
};

const RubyText = ({ children }: Props) => genRuby(children);

export default RubyText;
